import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      const snapshot = await getDocs(collection(db, "orders"));
      const orderList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setOrders(orderList);
    };
    fetchOrders();
  }, []);

  const handleUpdate = async (orderId, field, value) => {
    try {
      const orderRef = doc(db, "orders", orderId);
      await updateDoc(orderRef, { [field]: value });

      // Update UI state
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? { ...order, [field]: value } : order
        )
      );
    } catch (error) {
      console.error("Update failed:", error);
      alert("Update failed");
    }
  };

  const cellStyle = {
    border: "1px solid #ccc",
    padding: "8px",
    textAlign: "left",
    whiteSpace: "nowrap",
  };

  const headerStyle = {
    ...cellStyle,
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
  };

  const inputStyle = {
    width: "120px",
    padding: "4px",
  };

  const checkboxStyle = {
    width: "18px",
    height: "18px",
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📦 Orders List</h2>
      <div style={{ overflowX: "auto", marginTop: 20 }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "14px",
            minWidth: "1400px",
          }}
        >
          <thead>
            <tr>
              <th style={headerStyle}>Order ID</th>
              <th style={headerStyle}>Name</th>
              <th style={headerStyle}>Address</th>
              <th style={headerStyle}>State</th>
              <th style={headerStyle}>Pincode</th>
              <th style={headerStyle}>Landmark</th>
              <th style={headerStyle}>Phone</th>
              <th style={headerStyle}>Slot</th>
              <th style={headerStyle}>Services</th>
              <th style={headerStyle}>Total</th>
              <th style={headerStyle}>Timestamp</th>
              <th style={headerStyle}>Technician Phone</th>
              <th style={headerStyle}>Extra Parts</th>
              <th style={headerStyle}>Updated Total</th>
              <th style={headerStyle}>Status</th>
              <th style={headerStyle}>Work Completed</th>
              <th style={headerStyle}>Paid</th>
              <th style={headerStyle}>Cancelled</th>
              <th style={headerStyle}>Technician Status</th>
              <th style={headerStyle}>Payment Transferred</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td style={cellStyle}>{order.orderId}</td>
                <td style={cellStyle}>{order.name}</td>
                <td style={cellStyle}>{order.address}</td>
                <td style={cellStyle}>{order.state}</td>
                <td style={cellStyle}>{order.pincode}</td>
                <td style={cellStyle}>{order.landmark}</td>
                <td style={cellStyle}>{order.phone}</td>
                <td style={cellStyle}>{order.slot}</td>
                <td style={cellStyle}>{order.services}</td>
                <td style={cellStyle}>{order.total}</td>
                <td style={cellStyle}>{order.timestamp}</td>

                {/* Assigned Technician - Editable */}
                <td style={cellStyle}>
                  <input
                    type="text"
                    value={order.assignedTechnicianPhone || ""}
                    onChange={(e) =>
                      handleUpdate(order.id, "assignedTechnicianPhone", e.target.value)
                    }
                    placeholder="Phone"
                    style={inputStyle}
                  />
                </td>

                <td style={cellStyle}>{order.extraParts}</td>
                <td style={cellStyle}>{order.updatedTotal}</td>
                <td style={cellStyle}>{order.status}</td>
                <td style={cellStyle}>{order.workCompleted ? "✅" : "❌"}</td>

                {/* Paid - Toggle */}
                <td style={cellStyle}>
                  <input
                    type="checkbox"
                    checked={order.paid || false}
                    onChange={(e) =>
                      handleUpdate(order.id, "paid", e.target.checked)
                    }
                    style={checkboxStyle}
                  />
                </td>

                <td style={cellStyle}>{order.cancelled ? "❌" : "✅"}</td>
                <td style={cellStyle}>{order.technicianStatus}</td>

                {/* Payment Transferred - Manual Amount */}
                <td style={cellStyle}>
                  <input
                    type="text"
                    value={order.paymentTransferred || ""}
                    placeholder="₹ Amount"
                    onChange={(e) =>
                      handleUpdate(order.id, "paymentTransferred", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Orders;
